import { MantineThemeOverride } from '@mantine/core';

export type GroupTheme = NonNullable<MantineThemeOverride['components']>['Group'];

export const Group: GroupTheme = {
  // todo: define
};
